export default "__VITE_ASSET__16585642__"